import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface CustomersIconProps {
  isSelected?: boolean;
  isHover?: boolean;
  style?: React.CSSProperties;
}

export default function CustomersIcon({
  isSelected = false,
  isHover = false,
  style = {},
  ...props
}: CustomersIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 19 20" style={{ width: `20px`, height: `20px`, ...style }}>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.1945 9.44149C18.1945 13.4128 15.3335 16.7405 11.4955 17.6211C10.8353 17.7736 9.98143 19.4332 9.44446 19.4332C8.82826 19.4332 8.08002 17.7736 7.43742 17.6296C3.57298 16.7575 0.694458 13.4212 0.694458 9.43302C0.694458 4.80127 4.61171 1.0332 9.44446 1.0332C14.2772 1.0332 18.1945 4.80127 18.1945 9.44995V9.44149Z"
          stroke={isHover ? RoutalPalette.primary20 : isSelected ? RoutalPalette.primary40 : RoutalPalette.secondary40}
          strokeMiterlimit="10"
          fill="transparent"
        />
        <path
          d="M9.44446 10.9406C11.2321 10.9406 12.6812 9.54939 12.6812 7.83327C12.6812 6.11714 11.2321 4.72595 9.44446 4.72595C7.65683 4.72595 6.20767 6.11714 6.20767 7.83327C6.20767 9.54939 7.65683 10.9406 9.44446 10.9406Z"
          fill={isHover ? RoutalPalette.primary20 : isSelected ? RoutalPalette.primary40 : RoutalPalette.secondary40}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.96815 11.1653C5.94782 11.2552 5.06609 11.4844 4.17184 12.0664C2.70777 13.0162 2.09619 14.9499 3.40274 16.0794C5.07066 17.5169 7.33163 17.9362 7.33163 17.9362C7.65683 18.0061 8.00773 18.43 8.35653 18.8514C8.73326 19.3065 9.10753 19.7587 9.44434 19.7587C9.78114 19.7587 10.1554 19.3065 10.5321 18.8514C10.8809 18.43 11.2318 18.0061 11.557 17.9362C11.557 17.9362 13.818 17.5169 15.4859 16.0794C16.7925 14.9499 16.1809 13.0162 14.7168 12.0664C13.8236 11.4801 12.9429 11.2516 11.9241 11.163C11.2238 11.6486 10.3659 11.9333 9.44446 11.9333C8.52446 11.9333 7.66782 11.6495 6.96815 11.1653Z"
          fill={isHover ? RoutalPalette.primary20 : isSelected ? RoutalPalette.primary40 : RoutalPalette.secondary40}
        />
      </g>
    </SvgIcon>
  );
}
